import React, { useEffect, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { ContentSections } from './ContentSections';
import { ProductSection } from './ProductSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { TestimonialsSection } from './TestimonialsSection';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { PurchasePopup } from './PurchasePopup';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/ckgkavBjXxDS56EhcD7ajp/landing_-_Editada.png';
export function LandingPage() {
  useEffect(() => {
    // 1. Preload the LCP hero image so the browser discovers it immediately
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = HERO_IMAGE_URL;
    preloadLink.setAttribute('fetchpriority', 'high');
    document.head.appendChild(preloadLink);
    // 2. Preconnect to external domains
    const preconnects = ['https://cdn.magicpatterns.com', 'https://connect.facebook.net'];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      document.head.appendChild(link);
    });
    // 3. Load Meta Pixel only after user interaction (scroll/click/touch)
    //    This avoids loading 94 KiB of unused JS on initial page load
    let pixelLoaded = false;
    const loadPixel = () => {
      if (pixelLoaded) return;
      pixelLoaded = true;
      // Remove listeners once triggered
      window.removeEventListener('scroll', loadPixel);
      window.removeEventListener('click', loadPixel);
      window.removeEventListener('touchstart', loadPixel);
      const pixelId = '1555659168850991';
      try {
        const w = window as any;
        if (!w.fbq) {
          const fbq = function (...args: any[]) {
            if (fbq.callMethod) {
              fbq.callMethod.apply(fbq, args);
            } else {
              fbq.queue.push(args);
            }
          } as any;
          fbq.push = fbq;
          fbq.loaded = true;
          fbq.version = '2.0';
          fbq.queue = [] as any[];
          w.fbq = fbq;
          if (!w._fbq) w._fbq = fbq;
        }
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', pixelId);
        w.fbq('track', 'PageView');
      } catch (e) {
        console.warn('Meta Pixel failed to initialize:', e);
      }
    };
    // Listen for first user interaction to trigger pixel load
    window.addEventListener('scroll', loadPixel, {
      once: true,
      passive: true
    });
    window.addEventListener('click', loadPixel, {
      once: true
    });
    window.addEventListener('touchstart', loadPixel, {
      once: true,
      passive: true
    });
    // Fallback: load after 5 seconds if no interaction
    const fallbackTimer = setTimeout(loadPixel, 5000);
    return () => {
      clearTimeout(fallbackTimer);
      window.removeEventListener('scroll', loadPixel);
      window.removeEventListener('click', loadPixel);
      window.removeEventListener('touchstart', loadPixel);
    };
  }, []);
  return <div className="min-h-screen bg-gray-100 font-sans selection:bg-green-200 selection:text-green-900" data-id="element-199">
      <main className="w-full bg-white shadow-2xl mx-auto" data-id="element-200">
        <HeroSection data-id="element-201" />
        <ContentSections data-id="element-202" />
        <ProductSection data-id="element-203" />
        <BeforeAfterSection data-id="element-204" />
        <BonusSection data-id="element-205" />
        <TestimonialsSection data-id="element-206" />
        <PricingSection data-id="element-207" />
        <FAQSection data-id="element-208" />
      </main>
      <PurchasePopup data-id="element-209" />
    </div>;
}